import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

import { TableFieldModel } from '@module-definition/table-field/common/table-field.models';
import { HttpService } from '@shared/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class FieldDefinitionService {
  private http = inject(HttpService);
  private tableFieldColumnsCache = new Map<number, Observable<TableFieldModel[]>>();

  getTableFields(entityInstanceId: number, tableFieldId: number) {
    const params = this.http.buildHttpParams({ entityInstanceId, id: tableFieldId });

    return this.http.get<TableFieldModel[]>(`_api/FieldDefinition/TableFields`, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  /** Column definitions (label, type, formattings, restrictions) for a table field, cached by field id. */
  getTableFieldColumns(tableFieldId: number): Observable<TableFieldModel[]> {
    if (!this.tableFieldColumnsCache.has(tableFieldId)) {
      this.tableFieldColumnsCache.set(tableFieldId, this.getTableFields(undefined, tableFieldId).pipe(shareReplay(1)));
    }
    return this.tableFieldColumnsCache.get(tableFieldId);
  }
}
